import styled from 'styled-components';

import background from 'assets/images/bg-cxi.png';

export const CxiModal = styled.div`
    align-items: center;
    background: no-repeat bottom center fixed;
    background-color: ${({ theme }) => theme.colors.lightGray};
    background-image: url(${background});
    background-size: cover;
    display: flex;
    flex-direction: column;
    gap: 3.2rem;
    height: 100%;
    justify-content: center;
    border-radius: 6px;
    .nextButton {
        width: 80%;
    }
    .skipButton {
        width: 80%;
        color: #56c1d6;
    }
`;

export const CXISetupIndexCard = styled.div`
    align-items: center;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0px 0px 15px #3428680d;
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
    justify-content: center;
    max-width: 68rem;
    padding: 0 0 3.2rem 0;
    text-align: center;
    width: 100%;

    button + button {
        margin-top: -0.8rem;
    }
`;

export const Image = styled.div`
    img {
        border-radius: 6px;
        width: 100%;
    }
`;

export const Title = styled.h1`
    color: ${({ theme }) => theme.colors.black};
    font-size: 2.4rem;
    font-weight: 600;
    margin: 0;
    max-width: 42rem;
`;

export const Descr = styled.p`
    color: ${({ theme }) => theme.colors.neutralDark};
    font-size: 1.4rem;
    font-weight: 400;
    margin: 0 auto;
    max-width: 58rem;
    text-align: center;
`;

export const BackgroundLayer = styled.div`
    position: absolute;
    width: 100vw;
    height: 100vh;
    opacity: 0.5;
    background-color: '#000000' !important;
`;
